import { TouchpointType } from "types/touchpoint";
import { FiltersToApplyOnCreativeTable } from "containers/admin/clients/campaign/components/filters-on-creative-table/filters-on-creative-table.types";

const TOUCHPOINT_TYPES_FILTERS = [
  { name: TouchpointType.EMAIL, description: "Email" },
  { name: TouchpointType.LANDING_PAGE, description: "Web page" },
  { name: TouchpointType.OTHER, description: "Other" },
];

export const CREATIVE_TABLE_FILTERS_DATA = [
  {
    title: "Channel",
    filterId: "type",
    options: TOUCHPOINT_TYPES_FILTERS,
  },
  {
    title: "Content type",
    filterId: "contentType",
    options: [],
  },
  {
    title: "Population type",
    filterId: "populationType",
    options: [],
  },
  {
    title: "Class",
    filterId: "classType",
    options: [],
  },
];

export const FILTER_ID_TO_TITLE: Record<string, string> = {
  type: "Channel",
  contentType: "Content type",
  populationType: "Population type",
  classType: "Class",
};

export const DEFAULT_FILTERS_TO_APPLY: FiltersToApplyOnCreativeTable = {
  type: [],
  contentType: [],
  populationType: [],
  classType: [],
};
